import { render, staticRenderFns } from "./Caroussel.vue?vue&type=template&id=6b0e16ae&scoped=true&"
import script from "./Caroussel.vue?vue&type=script&lang=js&"
export * from "./Caroussel.vue?vue&type=script&lang=js&"
import style0 from "./Caroussel.vue?vue&type=style&index=0&id=6b0e16ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0e16ae",
  null
  
)

export default component.exports